import { render, staticRenderFns } from "./PriceOrderAutograph.vue?vue&type=template&id=496d215d&scoped=true&"
import script from "./PriceOrderAutograph.vue?vue&type=script&lang=js&"
export * from "./PriceOrderAutograph.vue?vue&type=script&lang=js&"
import style0 from "./PriceOrderAutograph.vue?vue&type=style&index=0&id=496d215d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d215d",
  null
  
)

export default component.exports